module.exports = __webpack_public_path__ + "static/media/live-class-active.851b02f2.svg";